import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';

import GlobalStyle from './styles/global';

import * as themes from './styles/themes';

import Routes from './routes';

import useAppTheme from './hooks/theme';

import { AuthProvider } from '~/hooks/authentication';
import { NotificationsProvider } from '~/hooks/notifications';
import { ConnectionProvider } from '~/hooks/connection';
import { IAmodeProvider } from '~/hooks/iamode';
import { MenuProvider } from '~/hooks/menu';

import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = () => {
  const { currentTheme } = useAppTheme();

  return (
    <ThemeProvider theme={themes[currentTheme]}>
      <Router>
        <AuthProvider>
          <NotificationsProvider>
            <ConnectionProvider>
              <ToastContainer />
              <IAmodeProvider>
                <MenuProvider>
                  <Routes />
                </MenuProvider>
              </IAmodeProvider>
            </ConnectionProvider>
          </NotificationsProvider>
        </AuthProvider>
      </Router>
      <GlobalStyle />
    </ThemeProvider>
  );
};

export default App;
